<template>
  <wb-select-control
    class="otb-date-picker-input-group__extended--hour"
    :theme="theme"
    v-if="availableTime"
  >
    <wb-select>
      <label>{{ hourPlaceholder }}</label>
      <select @change="changeTime($event)">
        <option
          v-for="optionTime in availableTime"
          :disabled="optionTime.disabled"
          :key="`time-${optionTime.value}`"
          :value="optionTime.value"
          :selected="isSelected(optionTime)"
        >
          {{ optionTime.value }}
        </option>
      </select>
    </wb-select>
  </wb-select-control>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import { TimeOption } from '../../models/entities/timeslot.model';

import useTimePicker from '../../composables/time-picker.composable';

export default defineComponent({
  name: 'otb-time-picker',
  props: {
    availableTime: Array as () => TimeOption[],
    hourPlaceholder: String,
    selectedTime: Object as () => TimeOption,
    theme: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const TimePicker = useTimePicker(props, { emit });

    return {
      ...TimePicker,
    };
  },
});
</script>
<style src="./time-picker.scss" lang="scss"></style>
